export default "__VITE_ASSET__Bad$jPA2__"